const styles = (theme) => ({
  contentContainer: { display: "flex", flexDirection: "column", gap: 1 },
  licencasContainer: { width: "100%", mt: 2 },
  licencasPaper: { width: "100%", borderRadius: 4, overflow: "hidden" },
  licencasHeader: {
    p: 2,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  licencasTitle: { fontWeight: "bold" },
  licencasSearch: { width: 300 },
  licencasDatagridContainer: { p: 2, height: 400 },
  licencasDotContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
    gap: 1,
  },
  licencasDot: (color) => ({
    width: 12,
    height: 12,
    borderRadius: "50%",
    backgroundColor: color,
    boxShadow: "0 0 2px rgba(0,0,0,0.2)",
  }),
  chipVigencia: {
    backgroundColor: theme.palette.chip?.background?.success || theme.palette.success.main,
    color: theme.palette.chip?.colorText?.success || "#fff",
    border: "0.6px solid ",
    borderColor: theme.palette.chip?.colorText?.success || theme.palette.success.main,
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  chipProxima: {
    backgroundColor: theme.palette.chip?.background?.high || theme.palette.warning.main,
    color: theme.palette.chip?.colorText?.high || "#fff",
    border: "0.6px solid ",
    borderColor: theme.palette.colors?.orange?.medium || theme.palette.warning.main,
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  chipExpirado: {
    backgroundColor: theme.palette.chip?.background?.critical || theme.palette.error.main,
    color: theme.palette.chip?.colorText?.critical || "#fff",
    border: "0.1px solid ",
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors?.red?.darker || theme.palette.error.dark
        : theme.palette.colors?.red?.light || theme.palette.error.light,
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  chipDefault: {
    border: "0.1px solid ",
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
});

export default styles;
